module.exports = __webpack_public_path__ + "static/img/大数据体验厅.6fe3db44.png";